import { styled, SvgIcon } from "@mui/material";

export const BaseSvgIcon = styled(SvgIcon)({
  fill: "none",
  // fontSize: "inherit",
});

export default BaseSvgIcon;
